// extracted by mini-css-extract-plugin
export default {"popup":"styled_popup__ogbwl"};